import { render, staticRenderFns } from "./skiiScore.vue?vue&type=template&id=0d016273&scoped=true"
import script from "./skiiScore.vue?vue&type=script&lang=js"
export * from "./skiiScore.vue?vue&type=script&lang=js"
import style0 from "./skiiScore.vue?vue&type=style&index=0&id=0d016273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d016273",
  null
  
)

export default component.exports